/* NUGGLES LIVE page: next-live countdown, live check, shoppable replay player.
   Nothing heavy loads until someone presses play. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LIVE_WINDOW_BEFORE = 15 * 60 * 1000;   // treat as "live" from 15 min before start
  var LIVE_WINDOW_AFTER = 2 * 60 * 60 * 1000; // until 2 hours after start
  var productCache = {};
  var hlsPromise = null;

  function $(sel, el) { return (el || document).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function clock(sec) {
    sec = Math.max(0, Math.floor(sec));
    var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
    return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(s).padStart(2, '0');
  }
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }
  function isApple() {
    var ua = navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|Android|Edg/.test(ua)) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }
  function loadHls(src) {
    if (!hlsPromise) {
      hlsPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src; s.async = true;
        s.onload = function () { resolve(window.Hls); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return hlsPromise;
  }
  // Timeline entries look like {"t": 75, "product": "<handle or product gid>"}
  function timelineFor(item) {
    var tl = Array.isArray(item.timeline) ? item.timeline.slice() : [];
    tl = tl.filter(function (x) { return x && typeof x.t === 'number' && x.product; });
    tl.sort(function (a, b) { return a.t - b.t; });
    return tl;
  }
  function findProduct(item, ref) {
    for (var i = 0; i < item.products.length; i++) {
      var p = item.products[i];
      if (p.handle === ref || p.gid === ref) return p;
    }
    return null;
  }

  /* ---------- Player ---------- */
  var player = null;
  function buildPlayer(sec) {
    var p = document.createElement('div');
    p.className = 'nlp';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'true');
    p.setAttribute('aria-label', 'Live replay');
    p.innerHTML =
      '<div class="nlp__box">' +
        '<div class="nlp__media">' +
          '<video class="nlp__video" controls playsinline preload="none"></video>' +
          '<button type="button" class="nlp__pop" data-pop></button>' +
        '</div>' +
        '<div class="nlp__side">' +
          '<div class="nlp__top"><div><h3 data-title></h3><small data-date></small></div>' +
            '<button type="button" class="nlp__close" data-close aria-label="Close">&times;</button></div>' +
          '<div class="nlp__list" data-list></div>' +
          '<a class="nlp__fb" data-fb target="_blank" rel="noopener" hidden>Watch on Facebook</a>' +
          '<div class="nlp__sheet" data-sheet></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(p);

    var v = $('video', p), sheet = $('[data-sheet]', p), pop = $('[data-pop]', p), list = $('[data-list]', p);
    var api = { el: p, hls: null, item: null, tl: [], nowRef: null, lastFocus: null };

    api.open = function (item, opener) {
      api.item = item;
      api.tl = timelineFor(item);
      api.nowRef = null;
      if (api.stopLivePoll) api.stopLivePoll();
      if (item.isLive && api.startLivePoll) api.startLivePoll();
      api.lastFocus = opener || document.activeElement;
      $('[data-title]', p).textContent = item.title || '';
      $('[data-date]', p).textContent = item.isLive ? 'Live now' : (item.date ? 'Replay · ' + item.date : '');
      var fb = $('[data-fb]', p);
      var fbUrl = item.fb || sec.dataset.fb;
      fb.hidden = !fbUrl; if (fbUrl) fb.href = fbUrl;
      renderList();
      pop.classList.remove('is-on');
      closeSheet();
      p.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      $('[data-close]', p).focus({ preventScroll: true });

      var url = 'https://stream.mux.com/' + encodeURIComponent(item.id) + '.m3u8';
      v.poster = item.poster || '';
      // Safari and iPhones play this stream type natively. Everyone else gets the
      // small player library, loaded only now. If one way fails, try the other.
      function useLibrary() {
        loadHls(sec.dataset.hlsSrc).then(function (Hls) {
          if (!Hls || !Hls.isSupported()) { v.src = url; v.play().catch(function () {}); return; }
          if (api.hls) api.hls.destroy();
          v.removeAttribute('src');
          api.hls = new Hls({ capLevelToPlayerSize: true });
          api.hls.loadSource(url);
          api.hls.attachMedia(v);
          v.play().catch(function () {});
        }).catch(function () { v.src = url; });
      }
      if (isApple() && v.canPlayType('application/vnd.apple.mpegurl')) {
        v.src = url;
        v.onerror = function () { v.onerror = null; useLibrary(); };
        v.play().catch(function () {});
      } else {
        v.onerror = null;
        useLibrary();
      }
    };
    api.close = function () {
      if (api.stopLivePoll) api.stopLivePoll();
      v.pause();
      if (api.hls) { api.hls.destroy(); api.hls = null; }
      v.onerror = null;
      v.removeAttribute('src'); v.load();
      p.classList.remove('is-open');
      closeSheet();
      document.documentElement.style.overflow = '';
      if (api.lastFocus && api.lastFocus.focus) api.lastFocus.focus({ preventScroll: true });
    };

    function renderList() {
      var item = api.item;
      list.innerHTML = item.products.length ? '' : '<p style="padding:14px 0;color:#6f6662">No products tagged on this live.</p>';
      item.products.forEach(function (prod) {
        var moments = api.tl.filter(function (x) { return x.product === prod.handle || x.product === prod.gid; });
        var row = document.createElement('div');
        row.className = 'nlp__item';
        row.dataset.ref = prod.handle;
        row.innerHTML =
          (prod.image ? '<img src="' + esc(prod.image) + '" alt="" width="56" height="70">' : '') +
          '<div class="nlp__item-info"><b>' + esc(prod.title) + '</b>' +
            '<div class="nlp__price">' + esc(prod.price) + (prod.compare ? '<s>' + esc(prod.compare) + '</s>' : '') + '</div>' +
            (moments.length ? '<button type="button" class="nlp__jump" data-t="' + moments[0].t + '">▶ Watch at ' + clock(moments[0].t) + '</button>' : '') +
          '</div>' +
          '<button type="button" class="nlp__shop">' + (prod.available ? 'Shop' : 'View') + '</button>';
        $('.nlp__shop', row).addEventListener('click', function () { openSheet(prod); });
        var jump = $('.nlp__jump', row);
        if (jump) jump.addEventListener('click', function () { v.currentTime = +jump.dataset.t; v.play().catch(function () {}); });
        list.appendChild(row);
      });
    }

    // Show the product that was being featured at this moment of the video.
    v.addEventListener('timeupdate', function () {
      if (!api.tl.length) return;
      var t = v.currentTime, cur = null;
      for (var i = 0; i < api.tl.length; i++) { if (api.tl[i].t <= t) cur = api.tl[i]; else break; }
      var ref = cur ? cur.product : null;
      if (ref === api.nowRef) return;
      api.nowRef = ref;
      showPop(ref ? findProduct(api.item, ref) : null);
    });

    function showPop(prod) {
      list.querySelectorAll('.nlp__item').forEach(function (row) {
        row.classList.toggle('is-now', !!prod && row.dataset.ref === prod.handle);
      });
      if (!prod) { pop.classList.remove('is-on'); return; }
      pop.innerHTML = (prod.image ? '<img src="' + esc(prod.image) + '" alt="">' : '') +
        '<span><b>' + esc(prod.title) + '</b><span>' + esc(prod.price) + '</span></span>';
      pop.onclick = function () { openSheet(prod); };
      pop.classList.remove('is-on'); void pop.offsetWidth; pop.classList.add('is-on');
    }

    // During a live: ask the helper feed what's being shown. The video runs about
    // 20 seconds behind real time, so wait that long before popping it up.
    var LIVE_DELAY = 20000, livePoll = null, liveWait = null, liveRef = null;
    function startLivePoll() {
      var url = sec.dataset.nowUrl;
      if (!url) return;
      function check() {
        fetch(url).then(function (r) { return r.json(); }).then(function (j) {
          var now = j && j.now;
          var ref = now ? now.handle : null;
          if (ref === liveRef) return;
          liveRef = ref;
          clearTimeout(liveWait);
          var prod = now ? (findProduct(api.item, now.handle) || {
            handle: now.handle, title: now.title, price: now.price, compare: now.compare,
            image: now.image, url: now.url, available: true
          }) : null;
          var wait = now ? Math.max(0, now.at + LIVE_DELAY - Date.now()) : 0;
          liveWait = setTimeout(function () { showPop(prod); }, wait);
        }).catch(function () {});
      }
      check();
      livePoll = setInterval(check, 5000);
    }
    function stopLivePoll() {
      clearInterval(livePoll); clearTimeout(liveWait);
      livePoll = liveWait = liveRef = null;
    }
    api.startLivePoll = startLivePoll;
    api.stopLivePoll = stopLivePoll;

    /* Size / color picker + add to cart */
    function closeSheet() { sheet.classList.remove('is-open'); }
    function openSheet(prod) {
      sheet.innerHTML =
        '<div class="nlp__sheet-head">' +
          (prod.image ? '<img src="' + esc(prod.image) + '" alt="">' : '') +
          '<div><b>' + esc(prod.title) + '</b><div class="nlp__price" data-sprice>' + esc(prod.price) +
          (prod.compare ? '<s>' + esc(prod.compare) + '</s>' : '') + '</div></div>' +
          '<button type="button" class="nlp__sheet-x" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div data-opts><div class="nlp__msg">Loading sizes…</div></div>' +
        '<button type="button" class="nlp__add" data-add disabled>Add to cart</button>' +
        '<div class="nlp__msg" data-msg aria-live="polite"></div>' +
        '<a class="nlp__link" href="' + esc(prod.url) + '">View full details</a>';
      sheet.classList.add('is-open');
      $('.nlp__sheet-x', sheet).addEventListener('click', closeSheet);
      fetchProduct(prod.handle).then(renderOptions).catch(function () {
        $('[data-opts]', sheet).innerHTML = '';
        $('[data-msg]', sheet).innerHTML = 'Couldn’t load sizes. <a href="' + esc(prod.url) + '">Open the product page</a>';
      });
    }
    function renderOptions(data) {
      var opts = $('[data-opts]', sheet), addBtn = $('[data-add]', sheet), msg = $('[data-msg]', sheet);
      var variants = data.variants || [];
      var names = (data.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      var single = variants.length === 1 && /default title/i.test(variants[0].title || '');
      var selected = [];
      function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
      names.forEach(function (n, i) {
        var vals = uniq(variants.map(function (x) { return x.options[i]; }));
        selected[i] = vals.length === 1 ? vals[0] : null;
      });
      if (single) selected = variants[0].options.slice();
      function match(sel) {
        return variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); });
      }
      function current() {
        if (selected.indexOf(null) > -1) return null;
        return match(selected)[0] || null;
      }
      function update() {
        opts.querySelectorAll('.nlp__val').forEach(function (b) {
          var i = +b.dataset.i, val = b.dataset.v, trial = selected.slice(); trial[i] = val;
          b.classList.toggle('is-selected', selected[i] === val);
          b.classList.toggle('is-unavailable', !match(trial).some(function (x) { return x.available; }));
        });
        var cv = current();
        msg.textContent = '';
        if (!cv) {
          var miss = selected.indexOf(null);
          addBtn.disabled = true;
          addBtn.textContent = 'Choose a ' + String(miss > -1 ? names[miss] : 'size').toLowerCase();
          return;
        }
        $('[data-sprice]', sheet).innerHTML = esc(money(cv.price)) + (cv.compare_at_price > cv.price ? '<s>' + esc(money(cv.compare_at_price)) + '</s>' : '');
        addBtn.disabled = !cv.available;
        addBtn.textContent = cv.available ? 'Add to cart' : 'Sold out';
      }
      opts.innerHTML = '';
      if (!single) {
        names.forEach(function (n, i) {
          var vals = uniq(variants.map(function (x) { return x.options[i]; }));
          if (vals.length === 1) return;
          var g = document.createElement('div');
          g.className = 'nlp__opt';
          g.innerHTML = '<div class="nlp__opt-name">' + esc(n) + '</div><div class="nlp__vals"></div>';
          vals.forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'nlp__val'; b.textContent = val; b.dataset.i = i; b.dataset.v = val;
            b.addEventListener('click', function () { selected[i] = val; update(); });
            $('.nlp__vals', g).appendChild(b);
          });
          opts.appendChild(g);
        });
      }
      update();
      addBtn.onclick = function () {
        var cv = current();
        if (!cv || !cv.available) return;
        addBtn.disabled = true; addBtn.textContent = 'Adding…';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: cv.id, quantity: 1 }] })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
        }).then(function () {
          addBtn.textContent = 'Added ✓';
          msg.innerHTML = '<a href="#" data-viewcart>View cart</a> or keep watching';
          $('[data-viewcart]', msg).addEventListener('click', function (e) {
            e.preventDefault();
            api.close();
            if (document.querySelector('.js-cart-drawer')) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            else window.location.href = root + 'cart';
          });
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: cv.id } }));
          setTimeout(function () { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }, 2500);
        }).catch(function (err) {
          addBtn.disabled = false; addBtn.textContent = 'Add to cart';
          msg.textContent = err.message || 'Couldn’t add to cart. Please try again.';
        });
      };
    }

    $('[data-close]', p).addEventListener('click', api.close);
    p.addEventListener('click', function (e) { if (e.target === p) api.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !p.classList.contains('is-open')) return;
      if (sheet.classList.contains('is-open')) closeSheet(); else api.close();
    });
    return api;
  }

  /* ---------- Next live card ---------- */
  function initNext(sec) {
    var card = $('[data-nl-next]', sec);
    var upcoming = [];
    try { upcoming = JSON.parse($('[data-nl-upcoming]', sec).textContent); } catch (e) { return; }
    var now = Date.now();
    upcoming = upcoming.filter(function (u) { return u.start + LIVE_WINDOW_AFTER > now; })
      .sort(function (a, b) { return a.start - b.start; });
    var next = upcoming[0];
    if (!next) return;

    $('[data-nl-next-title]', card).textContent = next.title;
    var d = new Date(next.start);
    $('[data-nl-when]', card).textContent = d.toLocaleString(undefined, { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    if (next.desc) $('[data-nl-desc]', card).textContent = next.desc;
    if (next.image) { var img = $('[data-nl-next-img]', card); img.src = next.image; img.hidden = false; }
    card.hidden = false;

    function tick() {
      var ms = next.start - Date.now();
      if (ms <= LIVE_WINDOW_BEFORE) { showLive(); return; }
      var m = Math.floor(ms / 60000);
      $('[data-d]', card).textContent = Math.floor(m / 1440);
      $('[data-h]', card).textContent = Math.floor((m % 1440) / 60);
      $('[data-m]', card).textContent = m % 60;
      setTimeout(tick, 30000);
    }
    var liveShown = false;
    function showLive() {
      if (liveShown) return; liveShown = true;
      $('[data-nl-count]', card).hidden = true;
      var eb = $('[data-nl-eyebrow]', card);
      var liveId = sec.dataset.liveId;
      if (!liveId) { eb.textContent = Date.now() >= next.start ? 'Live now on Facebook' : 'Starting soon'; return; }
      // Only now (around show time) do we ask Mux whether the stream is on.
      fetch('https://stream.mux.com/' + encodeURIComponent(liveId) + '.m3u8', { method: 'GET' }).then(function (r) {
        if (!r.ok) { eb.textContent = 'Starting soon'; setTimeout(function () { liveShown = false; showLive(); }, 60000); return; }
        eb.textContent = 'Live now';
        eb.classList.add('nl__eyebrow--live');
        var w = $('[data-nl-watch]', card);
        w.hidden = false;
        w.onclick = function () {
          player = player || buildPlayer(sec);
          player.open({ title: next.title, id: liveId, isLive: true, poster: next.image, fb: next.fb, products: next.products, timeline: next.timeline }, w);
        };
        // Came from the "We're live" bubble on another page: open the player right away.
        if (/[?&]watch=live\b/.test(location.search)) w.onclick();
      }).catch(function () { eb.textContent = 'Live now on Facebook'; });
    }
    tick();

    $('[data-nl-cal]', card).addEventListener('click', function () {
      function f(t) { return new Date(t).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
      var ics = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Nuggles//Live//EN', 'BEGIN:VEVENT',
        'UID:' + next.start + '@nuggles.us', 'DTSTAMP:' + f(Date.now()),
        'DTSTART:' + f(next.start), 'DTEND:' + f(next.start + 45 * 60000),
        'SUMMARY:' + ('NUGGLES LIVE: ' + next.title).replace(/[\n,;]/g, ' '),
        'URL:' + location.href.split('?')[0],
        'DESCRIPTION:Watch at ' + location.href.split('?')[0],
        'END:VEVENT', 'END:VCALENDAR'
      ].join('\r\n');
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
      a.download = 'nuggles-live.ics';
      document.body.appendChild(a); a.click(); a.remove();
    });
  }

  /* ---------- Replays ---------- */
  function initReplays(sec) {
    var data = null;
    sec.addEventListener('click', function (e) {
      var card = e.target.closest('[data-nl-open]');
      if (card) {
        if (!data) { try { data = JSON.parse($('[data-nl-replays]', sec).textContent); } catch (err) { return; } }
        var item = data[card.dataset.nlOpen];
        if (!item || !item.id) return;
        player = player || buildPlayer(sec);
        player.open(item, card);
        return;
      }
      if (e.target.closest('[data-nl-more]')) {
        sec.querySelectorAll('[data-nl-extra]').forEach(function (c) { c.hidden = false; });
        e.target.closest('.nl__more').remove();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-nl]').forEach(function (sec) {
      if (sec.__nl) return; sec.__nl = true;
      initNext(sec);
      initReplays(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
